export const blockIconsTransportationAirportShuttleNew = (
	<span className='material-symbols-outlined'>airport_shuttle</span>
);
